module.exports = __webpack_public_path__ + "static/media/ImageComponent_elBanner982162_1920_387898.55b5b97a.jpg";